import { render, staticRenderFns } from "./barcodes.vue?vue&type=template&id=bd71ddf6&"
import script from "./barcodes.vue?vue&type=script&lang=js&"
export * from "./barcodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports